.radio {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  cursor: pointer;
  padding: var(--spacing-2xs);
  transition: all 0.2s ease-in-out;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--color-brand-primary-light);
    outline-offset: 2px;
  }

  &--disabled {
    pointer-events: none;

    .radio__control {
      background-color: var(--color-neutral-neutral-lightest);
      border-color: var(--border-color-secondary);
    }

    .radio__input:checked + .radio__control {
      background-color: var(--color-neutral-neutral-lightest);
      border-color: var(--border-color-secondary);

      &::after {
        background-color: var(--color-neutral-neutral-light);
      }
    }

    .radio__label {
      color: var(--text-color-tertiary);
    }
  }

  &__input {
    position: absolute;
    opacity: 0;
    margin: 0;

    @include size(0);
  }

  &__control {
    position: relative;
    display: inline-block;

    @include size(18px);

    border: var(--border-size-sm) solid var(--border-color-primary);
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);

      @include size(8px);

      background-color: var(--background-color-primary);
      border-radius: 50%;
      transition: transform 0.2s ease-in-out;
    }
  }

  &__input:checked + &__control {
    background-color: var(--color-brand-primary-main);
    border-color: var(--color-brand-primary-main);

    &::after {
      transform: translate(-50%, -50%) scale(1);
    }
  }

  &:hover &__control {
    box-shadow: 0 0 0 1px rgb(0 0 0 / 100%);
  }

  &__input:checked:hover + &__control {
    background-color: var(--action-color-brand-primary-hover);
    border-color: var(--action-color-brand-primary-hover);
  }

  &__input:checked:hover:not(:focus) + &__control {
    box-shadow: none;
  }

  &__label {
    color: var(--text-color-primary);
    user-select: none;
  }

  &__input:focus + .radio__control {
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
  }
}
